import { render, staticRenderFns } from "./AssignmentSubmission.vue?vue&type=template&id=a7ab4646&"
import script from "./AssignmentSubmission.vue?vue&type=script&lang=ts&"
export * from "./AssignmentSubmission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports